<div class="modal-content" xmlns="http://www.w3.org/1999/html">
  <div class="modal-header">
    <h4 class="modal-title"><i class="fas fa-bars"></i> {{title | translate}}</h4>
    <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss('Cross click')">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <div class="no-gutters row">
      <div class="col-sm-6 col-md-4 col-xl-4">
        <div class="card no-shadow rm-border bg-transparent widget-chart text-left">
          <div class="icon-wrapper rounded-circle bg-warning text-center">
            <span class="icon-wrapper-bg opacity-10">
            <i class="fas fa-inbox fz-24 custom-ml-12 text-white"></i>
              </span>
          </div>
          <div class="widget-chart-content">
            <div class="widget-subheading">Total</div>
            <div class="widget-numbers text-warning">{{trayTotal}}</div>
            <div class="widget-description opacity-8 text-focus">
              <div class="d-inline pr-1">
                <i class="fa fa-angle-down"></i>
                <span class="pl-1">{{"LABEL.DELIVERED-TRAY" | translate}}</span>
              </div>
            </div>
          </div>
        </div>
        <div class="divider m-0 d-md-none d-sm-block"></div>
      </div>
      <div class="col-sm-6 col-md-4 col-xl-4">
        <div class="card no-shadow rm-border bg-transparent widget-chart text-left">
          <div class="icon-wrapper rounded-circle bg-primary">
            <div class="icon-wrapper-bg opacity-9">
              <i class="fas fa-mail-bulk fz-24 custom-ml-12 text-white"></i>
            </div>
          </div>
          <div class="widget-chart-content">
            <div class="widget-subheading">Total</div>
            <div class="widget-numbers text-primary"><span>{{mailTotal}}</span></div>
            <div class="widget-description opacity-8 text-focus">
              <i class="fa fa-angle-down"></i>
              {{"LABEL.MAIL-TRAY" | translate}}
            </div>
          </div>
        </div>
        <div class="divider m-0 d-md-none d-sm-block"></div>
      </div>
      <div class="col-sm-12 col-md-4 col-xl-4">
        <div class="card no-shadow rm-border bg-transparent widget-chart text-left">
          <div class="icon-wrapper rounded-circle bg-success">
            <div class="icon-wrapper-bg opacity-9 bg-success">
              <i class="fa fa-eye fz-24 custom-ml-12 text-white"></i></div>
          </div>
          <div class="widget-chart-content">
            <div class="widget-subheading">Total</div>
            <div class="widget-numbers text-success"><span>{{visualizedTotal}}</span></div>
            <div class="widget-description text-focus">
              <i class="fa fa-angle-down"></i>
              {{"LABEL.VISUALIZED" | translate}}
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-3 custom-mr-19 custom-col-md-3">
        <label for="state" class="font-weight-bold"> {{ "LABEL.STATE" | translate }}: </label>
        <div class="input-group">
          <div class="input-group-prepend">
            <div class="input-group-text"><i class="fas fa-star-half-alt"></i></div>
          </div>
          <select class="form-control"
                  [(ngModel)]="statusId"
                  (ngModelChange)="reloadBatchExecution()"
                  id="state">
            <option [value]=0>{{ "LABEL.ALL" | translate }}</option>
            <option [value]=3>{{ "LABEL.VISUALIZED" | translate }}</option>
            <option [value]=1>{{ "LABEL.DELIVERED-TRAY" | translate }}</option>
            <option [value]=2>{{ "LABEL.MAIL-TRAY" | translate }}</option>
          </select>
        </div>
      </div>
      <div class="col-md-3 custom-mr-19 custom-col-md-3">
        <label for="docnumberInput" class="font-weight-bold">{{ "LABEL.DOCUMENT-NUMBER" | translate }}:</label>
        <div class="input-group">
          <div class="input-group-prepend">
            <div class="input-group-text"><i class="fas fa-id-card"></i></div>
          </div>
          <input type="text"
                 id="docnumberInput"
                 class="form-control"
                 placeholder="{{ 'MESSAGE.ENTER-DOCUMENT-NUMBER' | translate }}"
                 [(ngModel)]="searchBatchloadingdocument.documentNumber"
                 (keyup.enter)="search()">
        </div>
      </div>
      <div class="col-md-3 custom-mr-19 custom-col-md-3">
        <label for="fullnameInput" class="font-weight-bold">{{ "LABEL.NAMES" | translate }}:</label>
        <div class="input-group">
          <div class="input-group-prepend">
            <div class="input-group-text"><i class="fas fa-user"></i></div>
          </div>
          <input type="text"
                 id="fullnameInput"
                 class="form-control"
                 placeholder="{{ 'MESSAGE.ENTER-NAMES' | translate }}"
                 [(ngModel)]="searchBatchloadingdocument.fullnamePerson"
                 (keyup.enter)="search()">
        </div>
      </div>
      <div class="col-md-3 custom-mt-24 custom-col-md-3">
        <button class="btn btn-outline-success w-100" type="button"
                (click)="search()">
          <i class="fa fa-search"></i> {{ "BUTTON.SEARCH" | translate }}
        </button>
      </div>
    </div>

    <div class="table-responsive mt-2 mb-2 custom-table-height">
      <table class="table-sm table-bordered">
        <thead>
        <tr>
          <th scope="col" title="#"></th>
          <th scope="col" title="{{ 'TABLE.HEADER.DOCUMENT-NUMBER' | translate }}"></th>
          <th scope="col" title="{{ 'TABLE.HEADER.COLLABORATOR' | translate }}"></th>
          <th scope="col" title="{{ 'TABLE.HEADER.MAIL' | translate }}"></th>
          <th scope="col" title="{{ 'TABLE.HEADER.DELIVERED-IN-TRAY' | translate }}"></th>
          <th scope="col" title="{{ 'TABLE.HEADER.SENT-TO-MAIL' | translate }}"></th>
          <th scope="col" title="{{ 'TABLE.HEADER.DISPLAYED' | translate }}"></th>
        </tr>
        </thead>
        <tbody>
        <tr *ngFor="let batchloadingdocument of batchloadingdocuments; let index=index">
          <td title="#"><b>{{(page.number * pageNumber) + index + 1}}</b></td>
          <td
            title="{{ 'TABLE.HEADER.DOCUMENT-NUMBER' | translate }}">{{batchloadingdocument.recipientDocumentNumber}}</td>
          <td title="{{ 'TABLE.HEADER.COLLABORATOR' | translate }}">{{batchloadingdocument.recipientFullname}}</td>
          <td title="{{ 'TABLE.HEADER.MAIL' | translate }}">{{batchloadingdocument.recipientEmail}}</td>
          <td title="{{ 'TABLE.HEADER.DELIVERED-IN-TRAY' | translate }}">
            <i class="{{iconClass(wasDelivered(batchloadingdocument))}}" placement="top"
               ngbTooltip="{{message(batchloadingdocument, DELIVERED)}}"></i>
          </td>
          <td title="{{ 'TABLE.HEADER.SENT-TO-MAIL' | translate }}">
            <i class="{{iconClass(wasSend2Email(batchloadingdocument))}}" placement="top"
               ngbTooltip="{{message(batchloadingdocument, SENT_2_MAIL)}}"></i>
          </td>
          <td title="{{ 'TABLE.HEADER.DISPLAYED' | translate }}">
            <i class="{{iconClass(wasVisualized(batchloadingdocument))}}" placement="top"
               ngbTooltip="{{message(batchloadingdocument, VISUALIZED)}}"></i>
          </td>
        </tr>
        </tbody>
      </table>
    </div>
    <nav class="Page navigation pagination-custom">
      <div class="row">
        <div class="col-md-8 mt-1">
          <div class="justify-content-row">
            <span class="mr-1 font-weight-normal">Mostrar </span>
            <select class="mr-1 br-6" [(ngModel)]="pageNumber"
                    (ngModelChange)="search()">
              <option *ngFor="let page of pageNumbers" [value]="page.value"
                      class="font-weight-bold">{{page.value}}</option>
            </select>
            <span class="font-weight-normal"> registros.</span>
          </div>
          <div class="page-total-entries">
            {{ "LABEL.TOTAL-RECORDS" | translate }}
            : {{batchloadingdocuments.length + (page.number * page.size)}} {{ "LABEL.OF" | translate }} {{page.totalElements}}
          </div>
        </div>
        <div class="col-md-4">
          <ul class="pagination justify-content-end text-center">
            <li class="page-item btn-paged-ends cursor-pointer {{page.number === 0 ? 'disabled' : ''}}">
              <a class="prev {{page.number === 0 ? 'disabled' : ''}}"
                 (click)="loadDetails(enumPage.First,batchloading.id)"
                 tabindex="-1" aria-disabled="true">
                <i class=" fa fa-angle-double-left" aria-hidden="true"></i>
                {{ "BUTTON.FIRST" | translate }}
              </a>
            </li>
            <li class="cursor-pointer {{page.number == 0 ? 'disabled' : ''}}">
              <a class="left"
                 (click)="loadDetails(enumPage.Previous,batchloading.id)">
                <i class="fa fa-angle-left" aria-hidden="true"></i></a>
            </li>
            <li
              class="cursor-pointer {{page.number === (page.totalPages - 1) || page.totalPages === 0 ? 'disabled':''}}">
              <a class="right"
                 (click)="loadDetails(enumPage.Next,batchloading.id)"><i
                class="fa fa-angle-right" aria-hidden="true"></i></a>
            </li>
            <li
              class="cursor-pointer {{page.number === (page.totalPages - 1) || page.totalPages === 0 ? 'disabled':''}}"
              (click)="loadDetails(enumPage.Last,batchloading.id)">
              <a class="next">
                {{ "BUTTON.LAST" | translate }}
                <i class="fa fa-angle-double-right" aria-hidden="true"></i>
              </a>
            </li>
          </ul>
        </div>
      </div>
    </nav>
  </div>
  <div class="modal-footer">
    <div class="container">
      <div class="row justify-content-end">
        <div class="col-md-12 text-center">
          <h4 class="modal-title">{{"TITLE.TOTAL" | translate}} {{totalNotification}}</h4>
        </div>
      </div>
    </div>
    <button type="button" class="btn btn-outline-success"
            (click)="accept()">{{ "BUTTON.ACCEPT" | translate }}
    </button>
  </div>
</div>
<app-loading *ngIf="loading"></app-loading>
